var map = {
	"./add-existing-registry-banner.gif": 1781,
	"./addexistingregistry_379x180_v2.jpg": 777,
	"./addexistingregistry_548x260.jpg": 1782,
	"./computer.png": 589,
	"./computer@2x.png": 1783,
	"./event.png": 281,
	"./event@2x.png": 1784,
	"./faq.png": 1785,
	"./faq@2x.png": 1786,
	"./home.png": 1787,
	"./home@2x.png": 1788,
	"./photo.png": 1789,
	"./photo@2x.png": 1790,
	"./poi.png": 1791,
	"./poi@2x.png": 1792,
	"./registry-video.jpg": 1793,
	"./registry-video@2x.jpg": 1794,
	"./registry.png": 1795,
	"./registry@2x.png": 1796,
	"./registryconversion_zolaintegration.jpg": 1797,
	"./registryconversion_zolaintegration@2x.jpg": 1798,
	"./rsvp.png": 1799,
	"./rsvp@2x.png": 1800,
	"./travel.png": 1801,
	"./travel@2x.png": 1802,
	"./wedding_party.png": 1803,
	"./wedding_party@2x.png": 1804
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1780;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1780
// module chunks = 50